















import { Vue, Component } from 'vue-property-decorator';
import Tag from './Tag.vue';
import { LoadingService } from '@/services/loadingService';
import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy } from '@/config/enums';

@Component({
  components: { Tag },
})
export default class TagPantalla extends Vue {
  readonly loadingService = new LoadingService();
  axios: AxiosVue = new AxiosVue(ServicioProxy.Metabase);
  readonly urlPg: string = 'Metabase/PostgenericA/track_corta_corriente/';
  //@ts-ignore
  readonly $snotify: any;
  showInfo: boolean = false;

  mounted() {}
}
